<template>
    <div class="bg-white">
        <div class="container py-4">
            <h1 class="py-5 mb-0">{{msg}}</h1>

            <div class="progress-container">
                <p class="progress__star">5 Sterne</p>
                <div class="progress">
                    <div class="progress-bar w-50" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <p class="progress__percentage">23.53%</p>
            </div>

            <div class="progress-container">
                <p class="progress__star">5 Sterne</p>
                <div class="progress">
                    <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <p class="progress__percentage">23.53%</p>
            </div>

            <div class="progress-container">
                <p class="progress__star">5 Sterne</p>
                <div class="progress">
                    <div class="progress-bar w-25" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <p class="progress__percentage">23.53%</p>
            </div>

            <div class="progress-container">
                <p class="progress__star">5 Sterne</p>
                <div class="progress">
                    <div class="progress-bar w-100" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <p class="progress__percentage">23.53%</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Progress",
        data() {
            return {
                msg: 'Progress'
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables";
    .progress {
        margin-bottom: 0;
        max-width: 70%;
        width: 70%;
        background-color: #F4F4F4;
        height: 1.6rem;
        border-radius: 0;

        &-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            max-width: 50%;
            margin-bottom: 2rem;

            p {
                margin-bottom: 0;
            }
        }

        .progress-bar {
            background-color: $alert-blue;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Progress.vue